$(document).ready(function () {
    $('.wheretoget-form button').removeAttr('disabled')
    // Zip Code Validation for Where To Get section
    $('.wheretoget-form form').on('submit', function (e) {
        e.preventDefault();

        const $form = $(this);
        const $input = $form.find('input[type="text"]');
        const $messageSpan = $form.find('.message');
        const zipCode = $input.val().trim();

        // Check if field is empty
        if (!zipCode) {
            $messageSpan.html('Please enter a zip code.');
            $input.focus();
            return;
        }

        if (!window.deliveryZones) {
            console.error('Delivery zones data is not available');
            return;
        }

        // Validate zip code
        let isValid = false;
        const zones = window.deliveryZones;
        for (const zone of zones) {
            if (zone.zip_codes.includes(zipCode)) {
                isValid = true;
                break;
            }
        }

        // Show message
        const message = isValid
            ? `Stocked is available in your area.`
            : `Stocked is not available in your area.`;

        $messageSpan.html(`
      ${message}<br>
      ${!isValid ? '<a href="#" class="check-another-zip">Check another zip code?</a>' : ''}
    `);

        // Handle "Check another zip code?" click
        $messageSpan.find('.check-another-zip').on('click', function (e) {
            e.preventDefault();
            $input.val('');
            $messageSpan.html('');
            $input.focus();
        });
    });
});
